<div class="spinner-container" *ngIf="isLoading$ | async">
  <mat-spinner></mat-spinner>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12 col-md-10 offset-md-1">
      <div class="login-page">

        <div class="login-brand">
          <img [routerLink]="['/private-area']" class="iren-logo mx-5" src="../../../content/assets/images/svg/LOGO_IREN_LGS.svg">
          <span class="mat-h1">Console IrenYou</span>
        </div>

        <form [formGroup]="formGroup" class="login-form" (ngSubmit)="login()">
          <div class="login-form-header">
            <span class="mat-display-1">Area personale console IrenYou</span>
            <span class="mat-body">Inserisci le tue credenziali per accedere</span>
          </div>

          <mat-form-field class="mb-4" appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="email" placeholder="Inserisci email" formControlName="email">

            <mat-hint>Inserisci la mail</mat-hint>

            <mat-error class="my-2" *ngIf="formGroup.get('email').touched && formGroup.controls.email.invalid">
              <span class="error" *ngIf="formGroup.get('email').errors?.required; else errorMatch">{{errorMessage.FIELD_REQUIRED}}</span>

              <ng-template #errorMatch>
                <span class="error" *ngIf="formGroup.get('email').errors?.pattern">{{errorMessage.EMAIL}}</span>
              </ng-template>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="mb-4" appearance="outline">
            <mat-label>Password</mat-label>
            <input matInput
                   type="{{password ? 'text':'password'}}"
                   placeholder="Inserisci password"
                   name="password"
                   formControlName="password">

            <mat-icon (click)="showPassword()" matSuffix>{{password ? 'visibility_off' : 'visibility' }}</mat-icon>
            <mat-hint>Inserisci la password</mat-hint>

            <mat-error class="my-2" *ngIf="formGroup.get('password').touched && formGroup.controls.password.invalid">
              <span class="error" *ngIf="formGroup.get('password').errors?.required">{{errorMessage.FIELD_REQUIRED}}</span>
            </mat-error>
          </mat-form-field>

          <button mat-raised-button type="submit" color="primary" class="text-light" [disabled]="!formGroup.valid">Login</button>
        </form>
      </div>
    </div>
  </div>
</div>
